<template>
  <button
    class="menu-item"
    :class="{ 'is-active': isActive ? isActive() : null }"
    :title="title"
    type="button"
    @click="() => action()"
  >
    <component :is="icon" />
  </button>
</template>

<script setup lang="ts">
import type { Component } from 'vue';

defineProps<{
  icon?: Component | string,
  title: string,
  action: Function,
  isActive?: Function,
}>();
</script>

<style lang="scss">
@import "@/assets/style/include.scss";

.menu-item {
  height: 28px;
  background: transparent;
  border: none;
  color: black;
  cursor: pointer;
  padding: 0.25rem;
  margin-right: 0.25rem;
  width: 1.75rem;

  svg {
    fill: currentColor;
    height: 100%;
    width: 100%;
  }

  &.is-active,
  &:hover {
    background-color: $colorBlue1;
    color: white;
  }
}
</style>
